var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"layout-container"},[_c('v-card',{staticClass:"text-center ma-16 pa-16"},[_c('ProgressCircular'),_c('h2',[_vm._v(_vm._s(_vm.$t('linkedin.process-authorization')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }